import { Directive, HostListener, Input } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  ValidatorFn
} from '@angular/forms';
import isValid from 'date-fns/isValid';
import parse from 'date-fns/parse';
import { CountryCode } from '../../../enum/src/lib/country-code.enum';
import { AppConfig } from '../../config/app.config';

const malaysia = 'malaysia';
// const philippines = 'philippines';
// 柬埔寨自然人
const cambodiaIndividual = 'cambodiaIndividual';
// 柬埔寨法人
const cambodiaCorporate = 'cambodiaCorporate';

@Directive({
  selector: '[sigvCheckId]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: CheckIdDirective,
      multi: true,
    },
  ],
})
export class CheckIdDirective {
  @Input() identityType: 'C' | 'I' | null = null;
  @Input() control!: AbstractControl | null;
  @Input() disableIdNoValid: boolean = false;

  isFocus = false;
  countryId: CountryCode;

  constructor(private appConfig: AppConfig) {
    this.countryId = this.appConfig.countryId as CountryCode;
  }

  @HostListener('blur')
  onblur(): void {
    this.isFocus = false;
    this.control?.updateValueAndValidity();
  }

  @HostListener('focus')
  onfocus(): void {
    this.isFocus = true;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    if (this.isFocus) {
      return null;
    } else {
      return control.value && this.disableIdNoValid === false
        ? checkIdDirectiveValidator(this.identityType, this.countryId)(control)
        : null;
    }
  }
}

export function checkIdDirectiveValidator(
  identityType: 'C' | 'I' | null,
  countryId: CountryCode
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let regString!: RegExp;
    let regResult: ValidationErrors | null = { idNotAllow: true };
    if (control.value === null) {
      return null;
    } else {
      const idType = getIdCheckType(identityType, countryId);
      switch (idType) {
        case malaysia:
          regString = /^[0-9]{12,12}$/;
          regResult =
            regString.test(control.value) &&
            isValid(parse(control.value.substr(0, 6), 'yyMMdd', new Date()))
              ? null
              : regResult;
          break;
        case cambodiaIndividual:
          regString = /^[0-9]{9,9}(?:\(\d{2}\))?$/;
          regResult = regString.test(control.value) ? null : regResult;
          break;
        case cambodiaCorporate:
          regString = /^[0-8]{8,8}$/;
          regResult = regString.test(control.value) ? null : regResult;
          break;
        default:
          regResult = null;
          break;
      }
      return regResult;
    }
  };
}

/**
 * 回傳國籍
 * @returns 回傳檢核設定 cambodiaCorporate | cambodiaIndividual | malaysia | none
 */
function getIdCheckType(
  identityType: 'C' | 'I' | null,
  countryId: CountryCode
): string | null {
  const { CAMBODIA, MALAYSIA } = CountryCode;

  // 依照國別及客戶類型設定檢查的 type
  const setting: {
    [countryKey in CountryCode]?: {
      [key: string]: string;
    };
  } = {
    [CAMBODIA]: {
      C: cambodiaCorporate,
      I: cambodiaIndividual,
    },
    [MALAYSIA]: {
      I: malaysia,
    },
  };

  if (!identityType) {
    return null;
  }

  return setting[countryId]?.[identityType] ?? null;
}
